import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=9c8eea4a"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"
import style0 from "./rule.vue?vue&type=style&index=0&id=9c8eea4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports